import {Pipe, PipeTransform} from '@angular/core';
import {BaseRatePipe} from './base-rate';
import {isNullOrUndefined} from '../../commons/utils';
import {DecimalAmountPipe} from '../decimal-input/decimal-input.pipe';

@Pipe({name: 'detailsRate'})
export class DetailsRatePipe extends BaseRatePipe implements PipeTransform {

  constructor(decimalAmountPipe: DecimalAmountPipe) {
    super(decimalAmountPipe);
  }

  // Rates are always shown with 4 decimals, regardless of magnitude
  transform(value: number): string {
    if (isNullOrUndefined(value)) {
      return '';
    }
    return super.transform(value);
  }
}
